import {FILTER_NAMES} from '../base.js'

export const ELECTRIC_AUTONOMY_OPTIONS = [50, 100, 200, 300, 400, 500, 600] // km
export const ELECTRIC_BATTERY_CAPACITY_OPTIONS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150] // kWh
export const ELECTRIC_CHARGING_TIME_FAST_MODE_OPTIONS = [30, 60, 120] // minutes
export const ELECTRIC_CHARGING_TIME_STANDARD_MODE_OPTIONS = [180, 360, 540, 720, 900, 1200, 1800] // minutes

export const FILTERS_OPTIONS = {
  [FILTER_NAMES.ELECTRIC_AUTONOMY]: ELECTRIC_AUTONOMY_OPTIONS,
  [FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY]: ELECTRIC_BATTERY_CAPACITY_OPTIONS,
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: ELECTRIC_CHARGING_TIME_FAST_MODE_OPTIONS,
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: ELECTRIC_CHARGING_TIME_STANDARD_MODE_OPTIONS
}
